<div class="sut-step-header-container flex flex-row gap-2 min-h-[32px] px-4 py-3" [ngClass]="{ selected: selected }">
  <div
    class="circle flex flex-col justify-center self-center h-8 w-8 min-w-[32px] min-h-[32px] rounded-full"
    [ngClass]="{ selected: selected }"
  >
    <div class="self-center font-semibold text-base">
      <span>{{ index + 1 }}</span>
    </div>
  </div>
  <div class="flex flex-grow flex-row gap-2 justify-between">
    <div class="self-center max-w-[164px]" style="font-size: 14px">
      {{ label }}
    </div>
    <ng-container [ngSwitch]="store.stepState$ | async">
      <div *ngSwitchCase="StepState.Warning" class="self-center" style="color: #ea9a3e" [matTooltip]="errorMessage">
        <mat-icon>warning</mat-icon>
      </div>
      <div *ngSwitchCase="StepState.Error" class="self-center" style="color: #de5133" [matTooltip]="errorMessage">
        <mat-icon>warning</mat-icon>
      </div>
      <div *ngSwitchCase="StepState.Completed" class="self-center" style="color: #37a063">
        <mat-icon>check_circle_outline</mat-icon>
      </div>
    </ng-container>
  </div>
</div>
